import React from 'react';
import { LinksRow } from "../common/links-row.component"

export const MenuSlice = ({slice}) => {
  return <LinksRow
    title={slice.primary.nav_text}
    links={slice.fields}
    className={`menu-slice list-unstyled ${slice.label || ''}`} />
}